/**
 * Production-safe logger utility
 * Logs are suppressed in production, shown in development
 */

/* eslint-disable no-console */
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDev) {
      console.log(...args);
    }
  },
  info: (...args) => {
    if (isDev) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    // Warnings are shown in all environments
    console.warn(...args);
  },
  error: (...args) => {
    // Errors are always shown
    console.error(...args);
  },
  debug: (...args) => {
    if (isDev) {
      console.debug(...args);
    }
  },
};

export default logger;
/* eslint-enable no-console */
